/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetVideosOptions, AdminGetVideosStatus200, AdminGetVideosStatus422 } from '../models/AdminGetVideos'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetVideos } from '../clients/axios/adminGetVideos'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetVideosQueryKey = ({ query }: Omit<AdminGetVideosOptions, 'headers'> = {}) => [{ url: '/admin/videos' }, ...(query ? [query] : [])] as const

type AdminGetVideosQueryKey = ReturnType<typeof adminGetVideosQueryKey>

export function adminGetVideosQueryOptions({ query }: AdminGetVideosOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetVideosQueryKey({ query })
  return queryOptions<AdminGetVideosStatus200, ResponseErrorConfig<AdminGetVideosStatus422>, AdminGetVideosStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetVideos({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary List Videos
 * {@link /admin/videos}
 */
export function useAdminGetVideos<TData = AdminGetVideosStatus200, TQueryData = AdminGetVideosStatus200, TQueryKey extends QueryKey = AdminGetVideosQueryKey>({ query }: { query?: AdminGetVideosOptions['query'] | (() => AdminGetVideosOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<AdminGetVideosStatus200, ResponseErrorConfig<AdminGetVideosStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetVideosQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetVideosQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetVideosStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
